<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <!--  Begin: List Card -->

        <!-- Begin: Page Option -->
        <div class="row">
          <div class="col-sm-12 text-right">
            <right-panel class="float-right" id="sidebar-department-process-pair" width="400px" :icon="'mdi mdi-plus'" :text="$t('common.add')" @hidden="rightPanelClosed">
              <div class="pl-5 pr-5">
                <Form :hide-library="true" :state="state" @onSave="multipleSave" />
              </div>
            </right-panel>
          </div>
        </div>
        <!-- End: Page Option -->

        <!-- Begin: Table -->

        <div class="bg-white">
          <table class="table table-bordered table-striped">
            <thead class="bg-secondary text-white">
              <tr>
                <th style="width: 100px">
                  <b-dropdown split :text="$t('common.select-all')" class="btn-block" variant="secondary" size="sm" @click="selectAllItems">
                    <template #button-content>
                      <b> {{ selectedItems.length > 0 ? $t("common.deselect-all") : $t("common.select-all-items") }}</b>
                    </template>
                    <b-dropdown-item href="#" @click="multipleDeleteById(selectedItems)" :disabled="!isAtLeastOneItemSelected">
                      <i class="bx bx-trash-alt text-danger" v-b-tooltip.hover :title="$t('common.delete')"></i> {{ $t("common.delete") }} ({{ selectedItems.length }})
                    </b-dropdown-item>
                    <b-dropdown-item href="#" @click="openModal()" :disabled="!isAtLeastOneItemSelected">
                      <i class="mdi mdi-plus-box-multiple text-primary" v-b-tooltip.hover :title="$t('common.add')"></i> {{ $t("common.add") }} ({{ selectedItems.length }})
                    </b-dropdown-item>
                  </b-dropdown>
                </th>
                <th>{{ $t("department.text") }}</th>
                <th>{{ $t("process.text") }}</th>
                <th>{{ $t("common.type") }}</th>
                <th scope="col" style="width: 15%">
                  <a href="javascript:;" @click="toggleFilter">
                    <span v-if="filterEnabled" class="text-warning">
                      <i class="bx bxs-filter-alt"></i>
                      {{ $t("common.filters-hide") }}
                    </span>
                    <span v-else class="text-white">
                      <i class="bx bxs-filter-alt"></i>
                      {{ $t("common.filters-show") }}
                    </span>
                  </a>
                </th>
              </tr>
            </thead>

            <tbody>
              <tr v-if="filterEnabled">
                <th></th>
                <th>
                  <filter-select
                    id="departmentFilter"
                    ref="departmentFilter"
                    :placeholder="$t('department.text')"
                    :multiple="false"
                    @filter="onDepartmentSearch"
                    @changed="onDepartmentSelect"
                  />
                </th>
                <th>
                  <filter-select id="processFilter" ref="processFilter" :placeholder="$t('process.text')" :multiple="false" @filter="onProcessSearch" @changed="onProcessSelect" />
                </th>
                <th></th>
              </tr>
              <template v-if="pagination">
                <tr v-for="item in pagination.docs" :key="item._id">
                  <td>
                    <div class="text-center">
                      <b-form-checkbox v-if="isCompatibleWithScope(item)" v-model="selectedItems" :value="item" class="custom-checkbox-primary mb-3 " checked></b-form-checkbox>
                    </div>
                  </td>

                  <td>{{ item.department.name | translate }}</td>
                  <td>{{ item.process.name | translate }}</td>
                  <td>
                    <span v-if="item.scope && isWorkspaceScopedItem(item)">{{ item.scope.value }}</span>
                    <span v-else>{{ $t("common.system") }}</span>
                  </td>
                  <td>
                    <div v-if="isCompatibleWithScope(item)" class="font-size-16 text-center">
                      <i class="bx bx-pencil text-primary hand" v-b-tooltip.hover :title="$t('common.edit')" @click="edit(item)"></i>
                      <i class="bx bx-trash text-danger hand ml-2" v-b-tooltip.hover :title="$t('common.edit')" @click="remove(item)"></i>
                    </div>
                  </td></tr
              ></template>
            </tbody>
          </table>
          <content-loading class="text-center" v-if="isLoading" />
        </div>
        <!-- End: Table -->

        <!-- Begin: Pagination -->

        <div v-if="pagination" class="row">
          <div class="col">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
            </ul>
          </div>
        </div>
        <!-- End: Pagination -->

        <b-modal id="modal-multiple-delete-operation-department-process" centered :title="$t('common.multiple-delete-operation')" hide-footer>
          <div v-if="deleteOperationResult">
            <div v-if="deleteOperationResult.success.length > 0">
              <h5 class="text-success">{{ $t("common.delete-items") }}</h5>
              <ul>
                <li v-for="item in deleteOperationResult.success" :key="item._id">
                  {{ item | translate }}
                </li>
              </ul>
            </div>

            <div v-if="deleteOperationResult.failed.length > 0">
              <h5 class="text-danger mt-4">{{ $t("common.delete-failed") }}</h5>
              <ul>
                <li v-for="item in deleteOperationResult.failed" :key="item._id">
                  <b> {{ item.name | translate }}</b>
                  {{ item.error }}
                </li>
              </ul>
            </div>
          </div>
        </b-modal>

        <b-modal id="departmentProcess" centered :title="$t('process.add-other-process')" hide-footer>
          <filter-select
            id="processFilter"
            ref="processFilter"
            :placeholder="$t('process.select')"
            :multiple="true"
            :isValid="!$v.form.process.$invalid"
            @filter="onProcessSearch"
            :selected="form.process"
            @changed="processSelect"
            track="_id"
          />

          <sweet-button
            @click="multipleSave()"
            type="submit"
            :loading="isUpdating"
            :disabled="isUpdating || $v.$invalid"
            variant="success"
            icon="mdi mdi-check"
            size="sm"
            buttonClass="mt-2"
          >
            {{ $t("common.save") }}
          </sweet-button>
        </b-modal>

        <b-modal id="modal-multiple-save-department-process" centered :title="$t('common.multiple-add-operation')" hide-footer>
          <div v-if="Object.keys(success).length > 0">
            <h5 class="text-success mt-4">{{ $t("common.added") }}</h5>
            <ul>
              <li v-for="key in Object.keys(success)" :key="key">
                <b> {{ success[key][0].department.name | translate }}</b>
                <ol>
                  <li v-for="i in success[key]" :key="i">{{ i.process.name | translate }}</li>
                </ol>
              </li>
            </ul>
          </div>

          <div v-if="Object.keys(fail).length > 0">
            <h5 class="text-danger mt-4">{{ $t("common.not-added") }}</h5>
            <ul>
              <li v-for="key in Object.keys(fail)" :key="key">
                <b> {{ fail[key][0].department.name | translate }}</b>
                <ol>
                  <li v-for="i in fail[key]" :key="i">{{ i.process.name | translate }}</li>
                </ol>
              </li>
            </ul>
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import FilterSelect from "@c/form/filter-select";
import RightPanel from "@c/right-panel";
import { required } from "vuelidate/lib/validators";
import Form from "./department-process-form.vue";

const state = "departmentProcess";
export default {
  components: {
    RightPanel,
    FilterSelect,
    Form,
  },
  props: ["state"],
  data() {
    return {
      form: { process: undefined },
      request: {
        options: { page: 1, limit: 15, sort: { ...(this.state === "workspaceDepartmentProcess" ? { "scope.workspace": "desc" } : { "scope.workspace": "asc" }) } },
        query: {},
      },

      filterEnabled: false,
      selectedItems: [],
      success: {},
      fail: {},
    };
  },
  validations: {
    form: {
      process: {
        required,
      },
    },
  },
  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.init());
      },
    },
  },
  mounted() {
    this.state = this.state || state;
  },
  computed: {
    isWorkspaceLayout() {
      return this.state === "workspaceDepartmentProcess";
    },
    pagination() {
      return this.$store.getters[`${this.state}/pagination`];
    },
    isLoading() {
      return this.$store.getters[`${this.state}/isLoading`];
    },
    isAtLeastOneItemSelected() {
      return this.selectedItems.length > 0;
    },
    deleteOperationResult() {
      return this.$store.getters[`${this.state}/deleteOperationResult`];
    },
    isUpdating() {
      return this.$store.getters[`${this.state}/isUpdating`];
    },
  },
  methods: {
    isCompatibleWithScope(item) {
      return (this.isWorkspaceLayout && this.isWorkspaceScopedItem(item)) || (!this.isWorkspaceLayout && !this.isWorkspaceScopedItem(item));
    },
    isWorkspaceScopedItem(item) {
      return item.scope?.value == "workspace";
    },
    init() {
      this.$store.dispatch(`${this.state}/paginate`, this.request);
    },
    selectAllItems() {
      if (this.selectedItems.length > 0) {
        this.selectedItems = [];
      } else {
        this.selectedItems = this.pagination.docs.slice();

        if (this.state === "workspaceDepartmentProcess") {
          this.selectedItems = this.selectedItems.filter((i) => i.scope?.value == "workspace");
        }
      }
    },

    async onDepartmentSearch(value, callback) {
      const store = this.isWorkspaceLayout ? "workspaceDepartment" : "managementDepartment";
      const response = await this.$store.dispatch(`${store}/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onDepartmentSelect(item) {
      if (item && Object.keys(item).length) {
        this.request.query = {
          ...this.request.query,
          department: item._id,
        };
      } else {
        this.request.query["department"] = null;
        delete this.request.query["department"];
      }
    },
    async onProcessSearch(value, callback) {
      const store = this.isWorkspaceLayout ? "workspaceProcess" : "managementProcess";
      const response = await this.$store.dispatch(`${store}/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onProcessSelect(item) {
      if (item && Object.keys(item).length) {
        this.request.query = {
          ...this.request.query,
          process: item._id,
        };
      } else {
        this.request.query["process"] = null;
        delete this.request.query["process"];
      }
    },
    rightPanelClosed() {
      this.$store.commit(`${this.state}/editedEntity`, null);
      this.init();
    },
    edit(item) {
      this.$store.commit(`${this.state}/editedEntity`, { ...item });
      this.$root.$emit("bv::toggle::collapse", "sidebar-department-process-pair");
    },
    async multipleDeleteById(selectedItems) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`${this.state}/multipleDelete`, selectedItems);
        this.init();
        this.selectedItems = [];
        this.$root.$emit("bv::toggle::modal", "modal-multiple-delete-operation-department-process");
      } catch (error) {
        console.error(error);
      }
    },
    async remove(record) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`${this.state}/delete`, record._id);
        this.init();

        this.$toast.success(
          "'" + this.$options.filters.translate(record.department.name) + "-" + this.$options.filters.translate(record.process.name) + "'  " + this.$t("common.delete-successful")
        );
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, {
          customMessage:
            "'" + this.$options.filters.translate(record.department.name) + "-" + this.$options.filters.translate(record.process.name) + "' " + this.$t("common.could-not-delete"),
        });
      }
    },
    toggleFilter() {
      this.filterEnabled = !this.filterEnabled;
    },
    openModal() {
      this.$root.$emit("bv::toggle::modal", "departmentProcess");
    },
    processSelect(item) {
      this.form = { ...this.form, process: item };
    },

    async multipleSave(departments, childProcesses) {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }
      this.fail = {};
      this.success = {};

      if (departments) {
        this.selectedItems = Array.isArray(departments) ? departments : [departments];
      }

      const requestedItems = [];

      for (const item of this.selectedItems) {
        const department = item.department ?? item;
        if (requestedItems.includes(department._id)) {
          continue;
        }
        let processes = this.form.process;
        if (childProcesses) {
          processes = Array.isArray(childProcesses) ? childProcesses : [childProcesses];
        }

        try {
          for (const process of processes) {
            try {
              await this.$store.dispatch(`${this.state}/save`, { process, department });

              if (this.success[department._id]) {
                this.success[department._id].push({ process, department });
              } else {
                this.success[department._id] = [{ process, department }];
              }
            } catch (error) {
              if (this.fail[department._id]) {
                this.fail[department._id].push({ process, department });
              } else {
                this.fail[department._id] = [{ process, department }];
              }
            }
            requestedItems.push(department._id);
          }
        } catch (e) {
          console.error(e);
        }
      }

      this.init();
      this.selectedItems = [];

      this.$root.$emit("bv::toggle::modal", "modal-multiple-save-department-process");
      if (this.$refs.processFilter) {
        this.$refs.processFilter.reset();
      }
      if (!departments || !childProcesses) {
        this.$root.$emit("bv::toggle::modal", "departmentProcess");
      }
      this.rightPanelClosed();
    },
  },
};
</script>
